import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isElectron: typeof window !== "undefined" &&
              window.navigator.userAgent.toLowerCase().includes("electron"),
};

const envSlice = createSlice({
  name: "env", // Redux state의 이름
  initialState, // 초기 상태값
  reducers: {}, // 상태를 변경하는 함수들 넣는 곳
});

export default envSlice.reducer;
